import {
	CHANGE_LANG,
	FETCHING,
	CHOOSE_TEAM,
	SET_SERVICES,
	UPDATE_SERVICE,
	SET_CZAS_PRACY,
	SET_MESSAGE,
	SET_DATE,
	SET_ACTIVE_MENU
} from "../actions";
import * as langsBase from "../translations";

export default (state = {}, action) => {
	switch (action.type) {
		case CHANGE_LANG:
			return {
				...state,
				language: action.lang,
				langBase: langsBase[action.lang],
				message: false,
				messageText: {
					text: null,
					typeMessage: null
				}
			};
		case FETCHING:
			return {
				...state,
				fetching: action.status
			};
		case CHOOSE_TEAM:
			return {
				...state,
				ekipa: action.ekipa,
				stepBtn: action.ekipa ? false : true
			};
		case SET_SERVICES:
			if (action.services) {
				return {
					...state,
					services: action.services,
					stepBtn: action.stepBtn
				};
			} else {
				return {
					...state,
					stepBtn: action.stepBtn
				};
			}

		case UPDATE_SERVICE:
			const index = state.services.findIndex((el) => el.name === action.updated.name);
			const services = [ ...state.services ];
			services[index] = { ...services[index], ...action.updated };
			return {
				...state,
				services
			};

		case SET_CZAS_PRACY:
			return {
				...state,
				czasPracy: action.czas
			};

		case SET_MESSAGE:
			if (action.typeMessage) {
				return {
					...state,
					message: true,
					messageText: {
						text: action.text,
						typeMessage: action.typeMessage
					}
				};
			} else {
				return {
					...state,
					message: false,
					messageText: {
						text: null,
						typeMessage: null
					}
				};
			}
		case SET_DATE:
			if (action.flag) {
				return {
					...state,
					date: action.date
				};
			} else {
				return {
					...state,
					date: null
				};
			}
		case SET_ACTIVE_MENU:
			if (action.id) {
				return {
					...state,
					activeMenu: action.id
				};
			} else {
				return {
					...state,
					activeMenu: null
				};
			}
		default:
			return state;
	}
};
